export default __webpack_public_path__ + "static/media/FreshAirIcon.2dafd5ad.svg";